import axios from 'axios';

const api = axios.create({
  baseURL: 'https://backend-legado-production.up.railway.app',
});

export default api;
